/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { CartTipFragment } from '../CartTipSelector/types/cartTipFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartPageVariables = Types.Exact<{ [key: string]: never }>

export type CartPage = {
  __typename: 'Query'
  currentCart: {
    __typename: 'Cart'
    id: number | null
    uuid: string | null
    pickupTimeSelected: boolean
    delayedPickupAt: any | null
    tipPercentage: number | null
    coupon: { __typename: 'CartCoupon'; id: number; code: string } | null
    amountCustomTip: {
      __typename: 'Money'
      formatted: string
      cents: number
    } | null
    price: {
      __typename: 'CartPrice'
      total: { __typename: 'Money'; formatted: string; cents: number }
      lines: Array<{
        __typename: 'PriceLine'
        name: string
        alwaysVisible: boolean
        tags: Array<Types.PriceLineTag>
        amount: { __typename: 'Money'; cents: number; formatted: string } | null
      }>
      items: Array<{
        __typename: 'CartItemPrice'
        quantity: number
        name: string
        taxIncluded: boolean
        total: { __typename: 'Money'; cents: number; formatted: string }
      }>
    }
    items: Array<{
      __typename: 'CartItem'
      id: string
      quantity: number
      specialInstructions: string
      questions: Array<{
        __typename: 'CartItemQuestion'
        locationItemQuestion: {
          __typename: 'LocationItemQuestion'
          id: number
          text: string
        }
        answers: Array<{
          __typename: 'LocationItemAnswer'
          id: number
          text: string | null
        }>
      }>
      locationItem: {
        __typename: 'LocationItem'
        id: number
        item: {
          __typename: 'Item'
          id: number
          name: string
          image: { __typename: 'ItemImage'; thumb: string; medium: string }
        }
      }
    }>
    location: {
      __typename: 'Location'
      id: number
      customerUrl: string
      asapOrdersEnabled: boolean
      delayedPickupEnabled: boolean
      availableOrderTimes: Array<any>
      workStatus: Types.LocationWorkStatus
      workStatusHuman: string
      startTime: any
      allowOrders: boolean
      tipsEnabled: boolean
      isFree: boolean
      lot: {
        __typename: 'Lot'
        id: number
        name: string
        address: string | null
        fullAddress: string
        lotUrl: string
      }
      truck: {
        __typename: 'Truck'
        id: number
        name: string
        scheduleUrl: string
        image: { __typename: 'TruckImage'; medium: string }
      }
    } | null
  } | null
}

export const CartPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CartPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentCart' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'cartTipFragment' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pickupTimeSelected' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'delayedPickupAt' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tipPercentage' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountCustomTip' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'formatted' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cents' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cents' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'formatted' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'alwaysVisible' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'taxIncluded' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cents' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'formatted' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quantity' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'specialInstructions' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'questions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'locationItemQuestion'
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'answers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locationItem' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'item' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'thumb' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'medium'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerUrl' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asapOrdersEnabled' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'delayedPickupEnabled' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableOrderTimes' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workStatus' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workStatusHuman' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startTime' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowOrders' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipsEnabled' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFree' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lot' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lotUrl' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'truck' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scheduleUrl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'medium' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    ...CartTipFragment.definitions
  ]
} as unknown as DocumentNode

/**
 * __useCartPage__
 *
 * To run a query within a React component, call `useCartPage` and pass it any options that fit your needs.
 * When your component renders, `useCartPage` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartPage({
 *   variables: {
 *   },
 * });
 */
export function useCartPage(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CartPage, CartPageVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CartPage, CartPageVariables>(
    CartPageDocument,
    options
  )
}
export function useCartPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CartPage,
    CartPageVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CartPage, CartPageVariables>(
    CartPageDocument,
    options
  )
}
export type CartPageHookResult = ReturnType<typeof useCartPage>
export type CartPageLazyQueryHookResult = ReturnType<
  typeof useCartPageLazyQuery
>
export type CartPageQueryResult = Apollo.QueryResult<
  CartPage,
  CartPageVariables
>
